import type { SkillTypes } from "@memorang/types";
import Icon from "@react-native-vector-icons/material-design-icons/static";
import { useTranslation } from "react-i18next";
import { Text } from "react-native-paper";
import type { IconType } from "../../icon";
import { useAppTheme } from "../../useAppTheme";
import Box from "../Box";

export const stimulusIconMap = {
	READING: "book-open-page-variant",
	WRITING: "file-document-edit-outline",
	LISTENING: "ear-hearing",
	SPEAKING: "microphone-outline",
} as const satisfies Record<SkillTypes, IconType>;

type Props = {
	skill?: SkillTypes;
	stiumulusIcon?: IconType;
	stiumulusTitle?: string;
	heading?: string;
	variant?: "default" | "header";
};

const StimulusInfo = ({
	skill,
	stiumulusIcon,
	stiumulusTitle,
	heading,
	variant = "default",
}: Props) => {
	const theme = useAppTheme();
	const { t, i18n } = useTranslation();

	const skillKey = skill ? `session.stimulusTypes.${skill.toLowerCase()}` : "";
	const formattedSkill = skill
		? i18n.exists(skillKey)
			? t(skillKey)
			: skill
		: stiumulusTitle;
	const icon = skill ? stimulusIconMap[skill] : stiumulusIcon;
	const stimulusCaption = `${formattedSkill} ${t("session.attributes.stimulus")}`;
	const displayLabel = heading ?? stimulusCaption;

	if (!(formattedSkill && icon)) {
		return null;
	}

	if (variant === "header") {
		return (
			<Box flexDirection="row" alignItems="center" gap={8}>
				<Icon name={icon} size={20} color={theme.colors.onSurface} />
				<Text
					style={{
						color: theme.colors.onSurface,
						fontSize: 16,
						fontWeight: "600",
					}}
				>
					{displayLabel}
				</Text>
			</Box>
		);
	}

	return (
		<Box flexDirection="row" alignItems="center" gap={8}>
			<Icon name={icon} size={24} color={theme.colors.text} />
			<Text variant="titleSmall">{displayLabel}</Text>
		</Box>
	);
};

export default StimulusInfo;
